exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*{margin:0px;padding:0px;}\nul,li{list-style-type:none;}\ninput{outline: none;border-radius: 0px;border:0 none;}\nhtml,body {\n    /*font-size: 20px!important;*/\n    min-height: 100%;\n    overflow-x:hidden;\n\t-webkit-tap-highlight-color:rgba(0,0,0,0);\t/*禁止链接高亮*/ \t\n\t-webkit-touch-callout:none;\t/*禁止链接长按弹出选项*/\n}\n.height-hide{\n\theight: 0px;\n\toverflow: hidden;\n}\n.bottom-nav a{\n\twidth: 33%;\n\ttext-align: center;\n\tcolor: #000;\n}\n.bottom-nav a ul{\n\twidth: 100%;\n}", ""]);

// exports
